import { useEffect } from 'react';

const useReloadPage = (message, enable) => {
  useEffect(() => {
    if (enable) {
      const handleBeforeUnload = (event) => {
        event.preventDefault();
        event.returnValue = message;
        return message;
      };

      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    }
  }, [message, enable]);
};

export default useReloadPage;
